/** @format */

export const MAKEROOM = "MAKEROOM";
export const AUTH = "AUTH";
export const CHECKAUTH = "CHECKAUTH";

export const LOGOUT = "LOGOUT";
export const SAVESETTINGS = "SAVESETTINGS";
